// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ModifierGroupRow-chevron__UdyDr{color:var(--gray-a10);transition:transform var(--duration-fast) ease}.ModifierGroupRow-chevronExpanded__nWd2h{transform:rotate(90deg)}.ModifierGroupRow-modifierList__JYgRI{display:flex;flex-wrap:wrap;gap:var(--size-2);margin:0;padding:var(--size-3);list-style:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chevron": "ModifierGroupRow-chevron__UdyDr",
	"chevronExpanded": "ModifierGroupRow-chevronExpanded__nWd2h",
	"modifierList": "ModifierGroupRow-modifierList__JYgRI"
};
export default ___CSS_LOADER_EXPORT___;
